import { Flex, styled, type FlexProps } from "@zenchef/styled-system/jsx";
import { aromaMemoBadge } from "@zenchef/styled-system/recipes";

import { slots } from "../../theme/recipes/memoBadge";
import { createStyleContext, Slot } from "../../utils/createStyleContext";
import { ComponentProps } from "react";
import { Text } from "../typography/Text";

const { withProvider, withContext } = createStyleContext(aromaMemoBadge);

export type MemoBadgeSlots = Slot<typeof aromaMemoBadge>;

const StyledDiv = styled("div");

export const slotsMaps = slots.reduce(
  (acc, slot) => ({ ...acc, [slot]: slot }),
  {} as Record<MemoBadgeSlots, MemoBadgeSlots>,
);

export const MemoBadgeWrap = withProvider<HTMLDivElement, FlexProps>(
  Flex,
  slotsMaps.wrap,
);

export const MemoBadgeDescription = withContext<
  HTMLDivElement,
  ComponentProps<typeof StyledDiv>
>(StyledDiv, slotsMaps.description);

export const MemoBadgeMenuTrigger = withContext<
  HTMLDivElement,
  ComponentProps<typeof StyledDiv>
>(StyledDiv, slotsMaps.menuTrigger);

export const MemoBadgeMenuDatesWrap = withContext<
  HTMLDivElement,
  ComponentProps<typeof StyledDiv>
>(StyledDiv, slotsMaps.datesWrap);

export const Title = withContext<HTMLSpanElement, ComponentProps<typeof Text>>(
  Text,
  slotsMaps.title,
);
